<template>
<div class="common-page-wrapper">
    <div class="page-head">
        <h3>Upcoming Events</h3>
        <!-- <vs-button @click="popupActive=true" color="primary" type="filled">CREATE NEW EVENT</vs-button> -->
        <vs-button @click="$router.push('/event/addv2')" color="primary" type="filled">CREATE NEW EVENT</vs-button>
    </div>
    <div class="event-list-horizontal">
        <div class="single-event">
            <div class="event-image">
                <img src="../../assets/images/new-asset/event-image.png"/>
            </div>
            <div class="event-details">
                <div class="event-details-up">
                    <div class="event-detailsup-left">
                        <span class="upcoming-event">Draft</span>
                        <h4>Sample Event 2020</h4>
                    </div>
                    <vs-button color="primary" type="border">Manage</vs-button>
                </div>
                <div class="event-details-down">
                    <div class="event-details-down-left">
                        <label>Event Date</label>
                        <h4>15 Dec - 17 Dec, 2020</h4>
                    </div>
                    <div class="event-details-down-right">
                        <div class="single-event-options">
                            <label>Publish</label>
                            <vs-switch class="ml-3" v-model="switch1" />
                        </div>
                        <div class="single-event-options">
                            <a href="">
                                <feather-icon  icon="CopyIcon" />
                            </a>
                        </div>
                        <div class="single-event-options">
                            <a href="">
                                <feather-icon  icon="Trash2Icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="event-list-horizontal">
        <div class="single-event">
            <div class="event-image">
                <img src="../../assets/images/new-asset/event-image.png"/>
            </div>
            <div class="event-details">
                <div class="event-details-up">
                    <div class="event-detailsup-left">
                        <span class="live-event">Live</span>
                        <h4>Sample Event 2020</h4>
                    </div>
                    <vs-button color="primary" type="border">Manage</vs-button>
                </div>
                <div class="event-details-down">
                    <div class="event-details-down-left">
                        <label>Event Date</label>
                        <h4>15 Dec - 17 Dec, 2020</h4>
                    </div>
                    <div class="event-details-down-right">
                        <div class="single-event-options">
                            <label>Publish</label>
                            <vs-switch class="ml-3" v-model="switch1" />
                        </div>
                        <div class="single-event-options">
                            <a href="">
                                <feather-icon  icon="CopyIcon" />
                            </a>
                        </div>
                        <div class="single-event-options">
                            <a href="">
                                <feather-icon  icon="Trash2Icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="event-list-horizontal">
        <div class="single-event">
            <div class="event-image">
                <img src="../../assets/images/new-asset/event-image.png"/>
            </div>
            <div class="event-details">
                <div class="event-details-up">
                    <div class="event-detailsup-left">
                        <span class="ended-event">Ended</span>
                        <h4>Sample Event 2020</h4>
                    </div>
                    <vs-button color="primary" type="border">Manage</vs-button>
                </div>
                <div class="event-details-down">
                    <div class="event-details-down-left">
                        <label>Event Date</label>
                        <h4>15 Dec - 17 Dec, 2020</h4>
                    </div>
                    <div class="event-details-down-right">
                        <div class="single-event-options">
                            <label>Publish</label>
                            <vs-switch class="ml-3" v-model="switch1" />
                        </div>
                        <div class="single-event-options">
                            <a href="">
                                <feather-icon  icon="CopyIcon" />
                            </a>
                        </div>
                        <div class="single-event-options">
                            <a href="">
                                <feather-icon  icon="Trash2Icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="event-list-horizontal">
        <div class="single-event">
            <div class="event-image">
                <img src="../../assets/images/new-asset/event-image.png"/>
            </div>
            <div class="event-details">
                <div class="event-details-up">
                    <div class="event-detailsup-left">
                        <span class="upcoming-event">Draft</span>
                        <h4>Sample Event 2020</h4>
                    </div>
                    <vs-button color="primary" type="border">Manage</vs-button>
                </div>
                <div class="event-details-down">
                    <div class="event-details-down-left">
                        <label>Event Date</label>
                        <h4>15 Dec - 17 Dec, 2020</h4>
                    </div>
                    <div class="event-details-down-right">
                        <div class="single-event-options">
                            <label>Publish</label>
                            <vs-switch class="ml-3" v-model="switch1" />
                        </div>
                        <div class="single-event-options">
                            <a href="">
                                <feather-icon  icon="CopyIcon" />
                            </a>
                        </div>
                        <div class="single-event-options">
                            <a href="">
                                <feather-icon  icon="Trash2Icon" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- // CREATE EVENT POPUP// -->
    <div class="create-new-event-popup-wrap">
            <vs-popup class="holamundo" title="" :active.sync="popupActive">
                <h3>Create Event</h3>
                <div class="event-form-wrapper">
                    <div class="mt-5">
                        <label>Event Name*</label>
                        <vs-input class="inputx w-full" placeholder="Event Name" v-model="value1" />
                    </div>
                    <div class="mt-5">
                        <label>Short Description of the event(Optional)</label>
                        <vs-textarea v-model="textarea" />
                    </div>
                    <div class="mt-5">
                        <label>Location</label>
                        <v-select :options="['USA','UK']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                    </div>
                    <div class="mt-5">
                     <label>Timezone</label>
                     <v-select :options="['(GMT+00:00) UTC','(GMT+00:30) UTC']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                    </div>
                    <div class="vx-row mt-5">
                        <div class="vx-col md:w-6/12 w-full">
                            <label>Start</label>
                            <flat-pickr class="w-full" :config="configdateTimePicker" v-model="datetime" placeholder="Date Time" />
                        </div>
                        <div class="vx-col md:w-6/12 w-full">
                            <label>End</label>
                            <flat-pickr class="w-full" :config="configdateTimePicker" v-model="datetime" placeholder="Date Time" />
                        </div>
                    </div>
                    <div class="mt-5">
                        <label>Language(Optional)</label>
                        <v-select :options="['English(US)','English(UK)']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                    </div>
                    <div class="access-section mt-5">
                        <p>Event Access <span><feather-icon icon="GlobeIcon" /></span></p>
                        <vs-dropdown vs-custom-content vs-trigger-click>
                            <a class="flex items-center" href.prevent>
                            <span>Public </span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4 ml-1" />
                            
                            </a>

                            <vs-dropdown-menu class="dropdown-login">
                                <vs-dropdown-item>
                                    Public
                                </vs-dropdown-item>

                                <vs-dropdown-item>
                                    Private
                                </vs-dropdown-item>
                            </vs-dropdown-menu>

                        </vs-dropdown>
                        <p><feather-icon icon="InfoIcon" /></p>
                        <div class="pt-5"></div>
                    </div>
                    <vs-button class="mt-8 w-full" color="success" type="filled">Create Event</vs-button>
                </div>
            </vs-popup>
    </div>
    <!-- // CREATE EVENT POPUP// -->
</div>
</template>
<script>
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  data() {
    return {
        popupActive: false,
        textarea: '',
        datetime: null,
        configdateTimePicker: {
            enableTime: true,
            dateFormat: 'd-m-Y H:i'
        },
    }
  },
  components: {
    'v-select': vSelect,
    flatPickr,
  },
}
</script>